import { ListingTable } from "../../../../components/layout/listing-table/listing-table.component";
import { IListingTable } from "../../../../components/layout/listing-table/listing-table.types";

interface ListingTableFlyerProp extends IListingTable {
  showIf: boolean;
  isListView: boolean;
}

export const ListingTableFlyer = (props: ListingTableFlyerProp) => {
  return (
    <div style={{ marginTop: props.isListView ? "-55px" : "0px" }}>
      <ListingTable
        columns={props.columns}
        dataList={props.dataList}
        link={props.link}
        showIf={props.showIf}
        minFirstColumnWidth={"180px"}
      />
    </div>
  );
};
